import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    ru_filters: [
      {
        letter : 'А',
        content: [
          {
            database_id: 1,
            title      : 'AUKOIL GENESIS Armortech 5W-40',
          },
          {
            database_id: 13,
            title      : 'LUKOIL GENESIS Claritech 5W-30',
          },
        ],
      },
      {
        letter : 'Я',
        content: [
          {
            database_id: 1,
            title      : 'AUKOIL GENESIS Armortech 5W-40',
          },
          {
            database_id: 13,
            title      : 'LUKOIL GENESIS Claritech 5W-30',
          },
          {
            database_id: 1,
            title      : 'AUKOIL GENESIS Armortech 5W-40',
          },
          {
            database_id: 13,
            title      : 'LUKOIL GENESIS Claritech 5W-30',
          },
        ],
      },
    ],
    eng_filters: [
      {
        letter : 'A',
        content: [
          {
            database_id: 1,
            title      : 'AUKOIL GENESIS Armortech 5W-40',
          },
          {
            database_id: 13,
            title      : 'AKOIL GENESIS Claritech 5W-30',
          },
        ],
      },
      {
        letter : 'Z',
        content: [
          {
            database_id: 1,
            title      : 'ZUKOIL GENESIS Armortech 5W-40',
          },
          {
            database_id: 13,
            title      : 'ZUKOIL GENESIS Claritech 5W-30',
          },
        ],
      },
    ],
    current_filter: 0,
    lang          : localStorage.getItem('lang') || 'ru',
  },
  getters: {
    ru_filters    : ({ru_filters}) => ru_filters.sort((a, b) => a.letter > b.letter),
    eng_filters   : ({eng_filters}) => eng_filters.sort((a, b) => a.letter > b.letter),
    current_filter: ({current_filter}) => current_filter,
    lang          : ({lang}) => lang,
  },
  mutations: {
    FILTER_RU(state, current) {
      state.lang = 'ru';
      state.current_filter = current;
    },
    FILTER_ENG(state, current) {
      state.lang = 'eng';
      state.current_filter = current;
    },
    SET_GLOSSARY(state, glossary) {
      state.ru_filters = glossary.ru_filters || [];
      state.eng_filters = glossary.en_filters || [];
    },
  },
  actions: {
    async get_glossary({commit}) {
      try {
        const get_glossary = await api.database.get_glossary();
        commit('SET_GLOSSARY', get_glossary.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
